export default "__VITE_ASSET__DemCHXSe__"